var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container d-flex align-items-start",class:_vm.type},[_c('img',{staticClass:"mr-10",attrs:{"src":_vm.icon}}),_c('p',{staticClass:"m-0 text-alert"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }